import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig.js";

export const usePostnatalConsultations = (pregnancyId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["postNatalConsultations", pregnancyId, tenantVal],
    queryFn: async () => {
      if (!pregnancyId) return [];

      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/postnatalconsultation/getbypregnancyid/${pregnancyId}`
      );

      const items = response.data?.data ?? response.data;

      return items.map((item) => ({
        id: item.id.toString(),
        title: "Post-natal consultation",
        date: item.consultationDate ? new Date(item.consultationDate) : new Date(),
        doctor: `${item?.pregnancy.conductedByStaffMember?.firstName} ${item?.pregnancy.conductedByStaffMember?.lastName}`,
        subject: {
          bornAt: new Date(item.bornAt),
          deliveryMethod: item.deliveryMethod,
          weightAtBirth: `${item.weightAtBirth}g`,
          jaundice: item?.jaundice?.toLowerCase() === "yes" ? "Yes" : "No",
          feeding: item.breastFeeding
            ? "Breast"
            : item.formulaFeeding
            ? "Formula"
            : item.combinationFeeding
            ? "Breast and Formula combination"
            : "-",
          issuesOfNote: item.issuesOfNote || "-",
          phnVisit: item.phvVisit || "-",
        },
        objective: {
          weight: item.weightInG ? `${item.weightInG}g` : "-",
          length: item.lengthInCm ? `${item.lengthInCm}cm` : "-",
          headCircumference: item.headCircumferenceInCm
            ? `${item.headCircumferenceInCm}cm`
            : "-",
          CRT: item.crt,
          umbilicus: item.umbilicus || "-",
          barlowAndOrtolaniTest: item.barlowAndOrtolaniTest || "-",
          heart: item.heart || "-",
          fontanelles: item.fontanelles || "-",
          buccalMucosa: item.buccalMucosa || "-",
          feet: item.feet || "-",
          impression: item.impression || "-",
          plan: item.plan || "-",
        },
        mother: {
          gravida: item.motherGravida,
          para: item.motherPara,
          issuesDuringOrSincePregnancy: item.issueDuringOrSincePregnancy || "-",
          postNatalMood: item.postNatalMood || "-",
          supports: item.motherSupports || "-",
          contraception: item.motherContraception || "-",
          mirena: item.motherMirena || "-",
        },
        attachments: {
          refferrals: [],
          prescriptions: [],
        },
      }));
    },
    enabled: !!pregnancyId && !!tenantVal,
  });
};
